import { createSlice } from "@reduxjs/toolkit";
import { duotoneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import _ from 'lodash';

const initialAccountsState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,

    error: "",
    errorType: "primary",
    showAlert: false,
};


export const callTypes = {
    list: "list",
    action: "action"
};

export const accountsSlice = createSlice({
    name: "accounts",
    initialState: initialAccountsState,
    reducers: {

        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            state.errorType = "danger";
            state.showAlert = true;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.showAlert = false;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        hideError: (state, action) => {
            state.error = null;
            state.errorType = '';
            state.showAlert = false;
        },

        accountsFetched: (state, action) => {
            const { data } = action.payload;
            state.error = null;
            state.errorType = '';
            state.showAlert = false;
            state.entities = data;
            state.totalCount = data.length;
        },

        accountInfoUpdated: (state, action) => {
            const {data} = action.payload;
            state.error = 'Successfully update account information';
            state.errorType = 'success';
            state.showAlert = true;
            console.log(state.entities)
            console.log(data);
            state.entities = [data, ...state.entities.filter(({accountId}) => accountId !== data.accountId)];
            state.totalCount = data.length;
        }
    }
});

